import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/web/src/components/AuthenticatedShell.tsx");
